
import { MultiLineChartWidgetComponent } from 'src/app/dashboard/widgets/multi-line-chart-widget/multi-line-chart-widget.component';
import { MultiLineChartWidget, Widget } from '../models/dashboard';
import { ActivityWidgetComponent } from '../widgets/activity-widget/activity-widget.component';
import { ChartWidgetComponent } from '../widgets/chart-widget/chart-widget.component';
import { WidgetTemplateTableComponent } from '../widgets/widget-template-table/widget-template-table.component';
import { WidgetTemplateTrendComponent } from '../widgets/widget-template-trend/widget-template-trend.component';
import { SystemStateWidgetComponent } from '../widgets/system-state-widget/system-state-widget.component';
import { CompanyEarningsWidgetComponent } from '../widgets/company-earnings-widget/company-earnings-widget.component';
import { UseOfGoodsWidgetComponent } from '../widgets/use-of-goods-widget/use-of-goods-widget.component';
import { FlexDashboardComponent, FlexDashboardWidgetLayout } from '../flex-dashboard/flex-dashboard.component';

export class WidgetFactory {
  static createTrendWidget(): Widget {
    return {
      content: WidgetTemplateTrendComponent,
      id: 0,
      widgetId: 1,
      label: 'Demo-Trend-Widget',
      rowSpan: 2,
      columnSpan: 2,
      columnPosition: 1,
      rowPosition: 1,
      contentData: JSON.stringify({
        trend: 221,
        total: 2420,
        days: 34,
      }),
    };
  }

  static createTableWidget(): Widget {
    return {
      content: WidgetTemplateTableComponent,
      id: 0,
      widgetId: 2,
      label: 'Demo-Table-Widget',
      rowSpan: 2,
      columnSpan: 2,
      columnPosition: 1,
      rowPosition: 1,
      contentData: JSON.stringify({
        title: 'Aktuelle Auslastung',
        columns: [
          { field: 'name', header: 'Name' },
          { field: 'value', header: 'Wert' },
        ],
        tableData: [
          { name: 'Server 1', value: 75 },
          { name: 'Server 2', value: 50 },
          { name: 'Server 3', value: 90 },
        ],
      }),
    };
  }

  static createChartWidget(): Widget {
    return {
      content: ChartWidgetComponent,
      id: 0,
      widgetId: 3,
      columnPosition: 1,
      rowPosition: 1,
      label: 'Demo-Chart-Widget',
      rowSpan: 2,
      columnSpan: 2,
    };
  }

  static createActivityWidget(): Widget {
    
    return {
      content: ActivityWidgetComponent,
      widgetId: 4,
      id: 0,
      columnPosition: 1,
      rowPosition: 1,
      label: 'Aktivität & News',
      rowSpan: 2,
      columnSpan: 2,
      
    };
  }

    static createSystemStateWidget(): Widget {
    
    return {
      content: SystemStateWidgetComponent,
      widgetId: 5,
      id: 0,
      columnPosition: 1,
      rowPosition: 1,
      label: 'System',
      rowSpan: 1,
      columnSpan: 1,
      
    };
  }

  static createCompanyEarningsWidget(): Widget {
    
    return {
      content: CompanyEarningsWidgetComponent,
      widgetId: 6,
      id: 0,
      columnPosition: 1,
      rowPosition: 1,
      label: 'Umsatz',
      rowSpan: 1,
      columnSpan: 1,
      
    };
  }

  static createUseOfGoodsWidget(): Widget {
    
    return {
      content: UseOfGoodsWidgetComponent,
      widgetId: 7,
      id: 0,
      columnPosition: 1,
      rowPosition: 1,
      label: 'Wareneinsatz',
      rowSpan: 1,
      columnSpan: 1,
      
    };
  }

  static createMultiLineChartWidget(): Widget {
    var multiLineChartWidget: MultiLineChartWidget = {
      chartRanges: [
        { name: 'Täglich', unit: 'day' },
        { name: 'Wöchentlich', unit: 'week' },
        { name: 'Monatlich', unit: 'month' },

    ],
    defaultChartRange: { name: 'Wöchentlich', unit: 'week' },
    bgColors: [
      ['rgba(37, 99, 235, 0.12)', 'rgba(37, 99, 235, 0)'],
      ['rgba(234, 127, 51, 0.15)', 'rgba(234, 127, 51, 0)']
    ],
    borderColors: ['rgba(37, 99, 235, 1)', 'rgba(234, 127, 51, 1)'],
    labels: ['Umsatz', 'Wareneinsatz']
    
      }
    return {
      content: MultiLineChartWidgetComponent,
      widgetId: 5,
      id: 0,
      columnPosition: 1,
      rowPosition: 1,
      label: 'Wareneinsatz und Umsatz',
      rowSpan: 2,
      columnSpan: 2,
      contentData: JSON.stringify(multiLineChartWidget)
    };
  }

  static createWidgetList(): Widget[] {
    return [
      WidgetFactory.createTrendWidget(),
      WidgetFactory.createTableWidget(),
      WidgetFactory.createChartWidget(),
      WidgetFactory.createActivityWidget(),
      WidgetFactory.createMultiLineChartWidget(),
    ];
  }

  static createWelcomeWidgets(): Widget[] {
    let activity = WidgetFactory.createActivityWidget();
    activity.id = 1;
    activity.rowPosition = 4;
    activity.columnPosition = 4;
    activity.rowSpan = 3;
    activity.columnSpan = 2;


    let companyEarningsWidget = WidgetFactory.createCompanyEarningsWidget();
    companyEarningsWidget.id = 6;
    companyEarningsWidget.rowPosition = 1;
    companyEarningsWidget.columnPosition = 1;
    companyEarningsWidget.rowSpan = 6;
    companyEarningsWidget.columnSpan = 3;

    let useOfGoodsWidget = WidgetFactory.createUseOfGoodsWidget();
    useOfGoodsWidget.id = 7;
    useOfGoodsWidget.rowPosition = 1;
    useOfGoodsWidget.columnPosition = 4;
    useOfGoodsWidget.rowSpan = 3;
    useOfGoodsWidget.columnSpan = 2;

    return [activity, companyEarningsWidget, useOfGoodsWidget];

  }

  static createWelcomeWidgetsFlex(hasReportsAccess: boolean): FlexDashboardWidgetLayout[] {
    const systemWidget: FlexDashboardWidgetLayout = {
      data: WidgetFactory.createSystemStateWidget(),
      widgetId: 5,
      order: hasReportsAccess ? 3 : 1,
      column: hasReportsAccess ? 'right' : 'left',
      heightMode: 'auto',
      minHeightPx: 70,
      heightPx: 0,
    };
    const activity: FlexDashboardWidgetLayout = {
      data: WidgetFactory.createActivityWidget(),
      widgetId: 4,
      order: hasReportsAccess ? 4 : 2,
      column: hasReportsAccess ? 'right' : 'left',
      heightMode: 'fill',
      minHeightPx: 260,
      heightPx: 0,
    };

    if (!hasReportsAccess) {
      return [systemWidget, activity];
    }

    const companyEarnings: FlexDashboardWidgetLayout = {
      data: WidgetFactory.createCompanyEarningsWidget(),
      widgetId: 6,
      order: 1,
      column: 'left',
      heightMode: 'fill',
      minHeightPx: 260,
      heightPx: 0,
    };
    const useOfGoods: FlexDashboardWidgetLayout = {
      data: WidgetFactory.createUseOfGoodsWidget(),
      widgetId: 7,
      order: 2,
      column: 'right',
      heightMode: 'auto',
      minHeightPx: 260,
      heightPx: 0,
    };

    return [companyEarnings, systemWidget, useOfGoods, activity];
  }
}
